export default __webpack_public_path__ + "static/media/Binance.c6c6e8a9.png";